export const PACKAGE_VERSION = "3.0.5169.0 (d74f355a)";
export const THEME = "polaris";